import __ from "standard/dunder";

const repaint = (_target, _propertyKey, descriptor) => {
  const next = descriptor.value;

  Object.assign(descriptor, {
    async value() {
      const output = await Reflect.apply(next, this, arguments);
      this[__.content__] && (await this[__.paint__]?.());
      return output;
    },
  });
};

export default repaint;
